<div class="action-panel-main">
  <div class="Skelton-section" *ngIf="tceChart.isSkelton">
    <div class="sektion-filter"><span class="Skelton-pp"></span></div>
    <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
    <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
    <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
    <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
  </div>
  <snl-action-panel *ngIf="!tceChart.isSkelton">
    <div left-side class="CommonFiltersPanel df-c"> 
      <div class="ResetFiltersTxt fw-700 df-c justify-content-start col-gap-16">
        <div class="sektion-filter" *ngIf="tceChart.isSkelton">
          <span class="Skelton-pp"></span>
        </div>
        <span class="color__primary section-title" *ngIf="!tceChart.isSkelton">Filter(s)</span>
        <a href="javascript:void(0);"*ngIf="!tceChart.isSkelton"[ngClass]="{'active': resetActivate() == true}" (click)="resetAll()" class="ResetAllTxt resetAllFlTxt section-title">Reset all</a>
      </div>
     <div class="dropdown-col _TextFltr _TextSubPool" *ngIf="!tceChart.isSkelton">
        <snl-dropdown
          [label]="'Pool'"
          [buttonPrimary]="'Apply'"
          [buttonSecondary]="'Clear'"
          [options]="tceChart.subpool"
          [preSelectedItems]="subPools"
          (selectedValues) = "selectedValues($event,'subpool')"
          (resetDropdown) ="resetDropdown($event,'subpool')"
          [multiple]="true"
        ></snl-dropdown>
      </div>
      <div class="dropdown-col _TextFltr _TextShipOwner" *ngIf="!tceChart.isSkelton">
          <snl-dropdown
            [label]="'Ship owner'"
            [buttonPrimary]="'Apply'"
            [buttonSecondary]="'Clear'"
            [options]="tceChart.shipOwner"
            [preSelectedItems]="shipOwners"
            (selectedValues) = "selectedValues($event,'shipOwners')"
            (resetDropdown) ="resetDropdown($event,'shipOwners')"
            [multiple]="true"
          ></snl-dropdown>
      </div>
      <div class="dropdown-col _TextFltr _TextShipClass" *ngIf="!tceChart.isSkelton">
          <snl-dropdown
            [label]="'Ship class'"
            [buttonPrimary]="'Apply'"
            [buttonSecondary]="'Clear'"
            [options]="tceChart.shipClass"
            [preSelectedItems]="vslClasses"
            (selectedValues) = "selectedValues($event,'vslClass')"
            (resetDropdown) ="resetDropdown($event,'vslClass')"
            [multiple]="true"
          ></snl-dropdown>
      </div>
      <div class="dropdown-col _TextFltr _TextShip" *ngIf="!tceChart.isSkelton">
         <snl-dropdown
            [label]="'Ship'"
            [buttonPrimary]="'Apply'"
            [buttonSecondary]="'Clear'"
            [options]="tceChart.shipName"
            [preSelectedItems]="shipNames"
            (selectedValues) = "selectedValues($event,'ship')"
            (resetDropdown) ="resetDropdown($event,'ship')"
            [multiple]="true"
          ></snl-dropdown>
      </div>
    </div> 
  </snl-action-panel>
  <snl-action-panel *ngIf="!tceChart.isSkelton">
    <div left-side class="action-button">
      <div class="df-c col-gap-8 chartaction">
        <span *ngIf="tceChart.switchType == 'Monthly'" class="round-btn-chart" [ngClass]="{ 'active':(tceChart.tceChartAction == 'ytd') }" (click)="tceChartSelected('ytd')">
          <snl-icon *ngIf="tceChart.tceChartAction == 'ytd'" class="" icon="fa fa-check"></snl-icon>YTD
        </span>
        <span class="round-btn-chart"[ngClass]="{ 'active':(tceChart.tceChartAction == 'all') }" (click)="tceChartSelected('all')">
          <snl-icon *ngIf="tceChart.tceChartAction == 'all'" class=""  icon="fa fa-check"></snl-icon>  All
        </span>
        <div class="month-range-chart" [ngClass]="{ 'active':(tceChart.tceChartAction == 'finMonthYear') }">
          <snl-date-picker-dropdown (click)="overlay()" 
            *ngIf="tceChart.monthDateDropdown && tceChart.switchType == 'Monthly'"
            datePickerType="single-month-range-selection"
            title = 'Custom month range'
            [startMonthDate] = "tceChart.endMonthDate"
            [endMonthDate] = "tceChart.endMonthDate"
            [min]="tceChart.finMinDate"
            [max]="tceChart.finMaxDate"
            [setDefaultDate]= false
            (selectedDate) = selectedDate($event)
          ></snl-date-picker-dropdown>          
          <app-year-picker *ngIf="tceChart.yearDateDropdown && tceChart.switchType == 'Yearly'"
              [label]="'Custom year range'"
              [min]="latestMonthYear.minYear"
              [max]="latestMonthYear.maxYear"
              (selectedYear) = "selectedYear($event)"
          ></app-year-picker>
        </div>
      </div>
    </div>
    <div right-side>
      <div class="df-c toggle col-gap-4" *ngIf="!tceChart.isSkelton">
        <snl-button-toggle (onChange)="monthYear($event)"
          [labels]="['Yearly', 'Monthly']"
          [disabled]= false
          [alignment]="'horizontal'"
          [ariaConfig]="ariaConfig"
          [defaultActive]= "defaultActive"
        ></snl-button-toggle>
      </div>
    </div>
  </snl-action-panel>
</div>

<div class="hightchart" id="hightchart">
  <div *ngIf="userRole === 1">  
    <div class="action-panel">
        <div class="heading">
          <p class="TitleChart df-c justify-content-start m-0 color__primary">
            <ng-container *ngIf="!tceChart.isSkelton">
              <span class="sub-heading-s1 fw-700">Time Charter Earnings (TCE)</span>
              <span class="sub-heading-s2 fw-400">&nbsp;($/ Op. day)</span>
              <!-- <img alt="download" (click) = "downloadPdf()" src="/assets/img/download-icon.svg"> -->
            </ng-container>
            <span class="Skelton-pp" *ngIf="tceChart.isSkelton"></span>
          </p>        
        </div>
        <div class="TceDataLabel-new skelton-section" *ngIf="tceChart.isSkelton">
          <div class="section">
            <span class="Skelton-pp"></span>
            <span class="Skelton-pp value"></span>
          </div>
          <div class="section">
            <span class="Skelton-pp"></span>
            <span class="Skelton-pp value"></span>
          </div>
        </div>
    </div>
    <div class="tceDataDiv">    
      <div class="TceDataLabel-new" *ngIf="!tceChart.isSkelton">
        <div class="section">
          <span class="body-b fw-400 color__secondary">Average TCE</span>
          <span class="sub-heading-s1 fw-700 color__primary avgTce">{{tceChart.averageTce | negativeToBracket: true}}</span>
        </div>
        <div class="section">
            <span class="body-b fw-400 color__secondary">{{fiscalYear}} YTD TCE</span>
            <span class="sub-heading-s1 fw-700 color__primary" *ngIf="tceChart.ytdTce">{{ tceChart.ytdTce | negativeToBracket: true}}</span>
        </div>      
      </div>
      <div class="TceCircleOpt">
        <span class="caption"  *ngIf="!tceChart.isSkelton"><em></em>TCE</span>
        <span class="caption" *ngIf="!tceChart.isSkelton">
          <svg width="40" height="4" viewBox="0 0 40 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2H40" stroke="#ECCBD9" stroke-width="4"/>
          </svg> 
          Average TCE
        </span>
        <span class="caption"  *ngIf="!tceChart.isSkelton">
          <svg width="40" height="4" viewBox="0 0 40 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2H40" stroke="#7FC8F8" stroke-width="4" stroke-dasharray="8 8"/>
          </svg> 
          Year to date TCE
        </span>      
      </div>
    </div>
    <div class="tceCr" *ngIf="tceChart.isSkelton"><span class="Skelton-pp" ></span></div>
    <highcharts-chart *ngIf="tceChart.highchartsWidth && tceChart.isHide && !tceChart.tceSkelton" 
      class="highcharts-chart pb-24" [ngStyle]="{'width':tceChart.highchartsWidth+'px'}" 
      [Highcharts]="Highcharts"
      [constructorType]="'stockChart'"
      [options]="chartOptions"
      [callbackFunction]="chartCallback">
    </highcharts-chart>
    <div class="highcharts-chart-skeltion" *ngIf="tceChart.tceSkelton"><span class="Skelton-pp"></span></div>
  </div>

  <div class="line"></div>

  <div class="netPoolOutChart pt-24">
    <div class="action-panel">
      <div class="heading">
        <p class="TitleChart df-c justify-content-start m-0 color__primary">
          <ng-container *ngIf="!tceChart.isSkelton">
            <span class="sub-heading-s1 fw-700">Net pool out</span>
            <span class="sub-heading-s2 fw-400">&nbsp;($/ Op. day)</span>
          </ng-container>
        </p>        
      </div>
    </div>
    <div class="tceDataDiv">    
      <div class="netPoolOutDataLabel" *ngIf="!tceChart.isSkelton">
        <div class="section">
          <span class="body-b fw-400 color__secondary">Average Net pool out</span>
          <span class="sub-heading-s1 fw-700 color__primary avgNetPoolOut">{{netPooloutPerOpDayChart.averageNetPoolout | negativeToBracket: true}}</span>
        </div>
        <div class="section">
            <span class="body-b fw-400 color__secondary">{{fiscalYear}} YTD Net pool out</span>
            <span class="sub-heading-s1 fw-700 color__primary" *ngIf="netPooloutPerOpDayChart.ytdNetPoolout">{{netPooloutPerOpDayChart.ytdNetPoolout | negativeToBracket: true}}</span>
        </div>        
      </div>
      <div class="TceCircleOpt">
        <span class="caption"  *ngIf="!tceChart.isSkelton"><em></em>Net pool out</span>
        <span class="caption" *ngIf="!tceChart.isSkelton">
          <svg width="40" height="4" viewBox="0 0 40 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2H40" stroke="#ECCBD9" stroke-width="4"/>
          </svg> 
          Average Net pool out
        </span>
        <span class="caption"  *ngIf="!tceChart.isSkelton">
          <svg width="40" height="4" viewBox="0 0 40 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2H40" stroke="#7FC8F8" stroke-width="4" stroke-dasharray="8 8"/>
          </svg> 
          {{fiscalYear}} YTD Net pool out
        </span>        
      </div>
    </div>
    <highcharts-chart *ngIf="tceChart.highchartsWidth && tceChart.isHide && !tceChart.tceSkelton" 
      class="highcharts-chart" [ngStyle]="{'width':tceChart.highchartsWidth+'px'}" 
      [Highcharts]="Highcharts"
      [constructorType]="'stockChart'"
      [options]="chartOptionsNetPoolout"
      [callbackFunction]="chartCallbackNetPoolOut">
    </highcharts-chart>
  </div>
</div>